import { render } from "./NoMenuLayout.vue?vue&type=template&id=c995de5a"
import script from "./NoMenuLayout.vue?vue&type=script&lang=js"
export * from "./NoMenuLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\CMS\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__